import React from 'react';
import FindRovers from './components/FindRovers';
import './App.css';

function App() {
  return (
    <div className="App">
      <FindRovers />
    </div>
  );
}

export default App;
